import { concat } from 'rxjs'
import { switchMap } from 'rxjs/operators'

import {
  createClearLoading$,
  createLoading$,
} from '@apiEnabler/api-enabler-common/lib/loading'
import { updateBiometricGeneratedState$ } from '@apiEnabler/ob-common/lib/biometric-consents'

import { createStoreNavigateTo$ } from './navigation'
import { displayBiometrics$ } from './intents'
import { initialData$ } from './customer'

export const biometricsDisplay$ = displayBiometrics$.pipe(
  switchMap(() =>
    concat(
      initialData$,
      createLoading$('Loading biometric consents'),
      createStoreNavigateTo$('/biometrics'),
      updateBiometricGeneratedState$,
      createClearLoading$('Loading biometric consents')
    )
  )
)
